import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COMMUNITY_FEATURE_KEY, CommunityState, CommunityPartialState, communityAdapter } from './community.reducer';

// Lookup the 'Community' feature state managed by NgRx
export const getCommunityState = createFeatureSelector<CommunityPartialState, CommunityState>(COMMUNITY_FEATURE_KEY);

const { selectAll, selectEntities } = communityAdapter.getSelectors();

export const getCommunityLoaded = createSelector(getCommunityState, (state: CommunityState) => state.loaded);

export const getCommunityError = createSelector(getCommunityState, (state: CommunityState) => state.error);

export const loadingCommunity = createSelector(getCommunityState, (state: CommunityState) => state.loaded);

export const getAllCommunity = createSelector(getCommunityState, (state: CommunityState) => selectAll(state));

export const getCommunityEntities = createSelector(getCommunityState, (state: CommunityState) => selectEntities(state));

export const getSelectedId = createSelector(getCommunityState, (state: CommunityState) => state.selectedCommunityId);

export const getSelected = createSelector(
	getCommunityEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
